export const getHotelUrl = (url = '') =>
  `${url}?utm_source=Home%20Page&utm_medium=alternative%20choice&utm_campaign=${window.location.host}`;
